import { jsxs, jsx } from 'react/jsx-runtime';
import classNames from 'classnames';

const BreadCrumbItem = ({ children })=>{
    return jsxs("li", {
        className: classNames('cb-breadcrumb-item'),
        children: [
            jsx("p", {
                className: classNames('separator'),
                "aria-hidden": true,
                children: "/"
            }),
            jsx("span", {
                className: classNames('item'),
                children: children
            })
        ]
    });
};
BreadCrumbItem.displayName = 'BreadCrumb.Item';

export { BreadCrumbItem };
//# sourceMappingURL=BreadCrumb.Item.es.js.map
